const Endash = () => <span className="mx-1">&ndash;</span>;

export default Endash;
